export default __webpack_public_path__ + "static/media/pxgroup02.4c7a8e54.png";